<app-header></app-header>
<div class="container-fluid">
  <div class="row main-card-style">
    <div *ngIf="isLoading; else content" class="spinner__loading">
      <mat-spinner></mat-spinner>
    </div>
    <ng-template #content>
      <!-- Select NP-->
      <div class="col-md-12">
        <div class="search-section1">
          <div class="col-md-2"><p class="text1">Select NursePractitioner </p></div>
          <div class="col-md-3">
            <mat-form-field appearance="none" class="manage-select">
              <mat-select matInput
                          placeholder="Select Nurse Practitioner"
                          [(ngModel)]="selectedProviderId">
                <mat-option *ngFor="let nursePractitioner of nursePractitioners" [value]="nursePractitioner.nursePractitionerId">
                  {{ nursePractitioner.firstName }} {{ nursePractitioner.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
      </div>
      <div *ngIf="selectedProviderId" style="float: left; width: 100%;">
        <app-availability [selectedProviderId]="selectedProviderId"
                          [minDateDays]="0"
                          [maxDateDays]="59">
        </app-availability>
      </div>
    </ng-template>
  </div>
</div>
<app-footer></app-footer>
